import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {Button, ButtonGroup} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUser} from "@fortawesome/free-solid-svg-icons";
import {Spinner} from "reactstrap";
import {
    ADMIN_GET_USERS
} from "../../../queries/queries";
import {useLazyQuery} from "@apollo/client";

import {number_format} from "../../../helpers";
import Pagination from "../../common/Pagination";


const AdminUsers = () => {

    const navigate = useNavigate();
    const [allRaffles, setAllRaffles] = useState([]);

    const [limit, setLimit] = useState(25);
    const [offset, setOffset] = useState(0);
    const [orderBy, setOrderBy] = useState(`id`);
    const [order, setOrder] = useState(`DESC`);
    const [maxPages, setMaxPages] = useState(0);
    const [totalCoins, setTotalCoins] = useState(0);
    const [loading, setLoading] = useState(false);

    const sort = (column) => {
        if(order == 'ASC'){
            setOrder('DESC');
        }else{
            setOrder('ASC');
        }

        setOrderBy(column);
    };

    // const [getAllUsers, {loading, refetch}] = useLazyQuery(ADMIN_GET_USERS, {
    //     variables: {
    //         orderBy, order, limit, offset
    //     },
    //     fetchPolicy: 'cache-and-network',
    //     onCompleted: (e) => {
    //         setAllRaffles(e.adminGetUsers);
    //         setMaxPages(Math.ceil(e.adminGetUsersCount / limit));
    //         setTotalCoins(e.adminGetUsersCoinsTotal);
    //     },
    //     onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    // });

    useEffect(() => {
        // getAllUsers();
    }, []);

    return (

        <div className="card text-bg-dark">
            <div className="card-header d-flex justify-content-between align-items-center">
                Users ({number_format(totalCoins)} coins)
            </div>

            <div className="card-body p-0">

                <Pagination
                    resultsPerPage={limit}
                    setResultsPerPage={setLimit}
                    maxPages={maxPages}
                    setOffset={setOffset}
                />

                <table className="table table-dark table-striped">
                    <thead>
                    <tr>
                        <th onClick={() => sort('id')}>
                            #
                        </th>
                        <th onClick={() => sort('displayName')}>
                            Name
                        </th>
                        <th onClick={() => sort('isValid')}>
                            Valid
                        </th>
                        <th onClick={() => sort('coins')}>
                            Coins
                        </th>
                        <th></th>
                    </tr>
                    </thead>
                    {loading ? (<Spinner/>) : (
                        <tbody>
                        {allRaffles && allRaffles.length > 0 ? (
                            <>
                                {allRaffles.map((row, index) => {
                                    return (<tr>
                                        <th scope="row">
                                            {row?.id}
                                        </th>
                                        <td>
                                            {row?.displayName}
                                        </td>
                                        <td>
                                            {row?.isValid ? 'Yes':'No'}
                                        </td>
                                        <td>
                                            {number_format(row.coins)}
                                        </td>
                                        <td style={{textAlign: 'right'}}>
                                            <ButtonGroup>
                                                <Button color="primary" onClick={() => navigate(`${row.id}`)}>
                                                    <FontAwesomeIcon icon={faUser}/>
                                                </Button>
                                            </ButtonGroup>
                                        </td>
                                    </tr>);
                                })}
                            </>
                        ) : (<></>)}

                        </tbody>
                    )}
                </table>

            </div>
        </div>
    );

};

export default AdminUsers;